import { render, staticRenderFns } from "./StepContent.vue?vue&type=template&id=34b3d274&scoped=true&"
import script from "./StepContent.vue?vue&type=script&lang=js&"
export * from "./StepContent.vue?vue&type=script&lang=js&"
import style0 from "./StepContent.vue?vue&type=style&index=0&id=34b3d274&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b3d274",
  null
  
)

/* custom blocks */
import block0 from "./StepContent.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports